import { IntegrationProviders } from 'app-constants'
import { IUserObject } from 'types'

export const isAccountConnected = (
  user: IUserObject | undefined,
  provider: IntegrationProviders | string | undefined
) => {
  if (!user || !provider) return false
  if (provider === IntegrationProviders.MORTA) return true

  for (const integration of user.integrations) {
    if (integration.provider === provider) {
      if (!integration.accessToken) return false
      // OAuth providers have refreshToken + expiresAt; API key providers don't
      if (integration.refreshToken !== undefined && integration.refreshToken !== null) {
        return !!(integration.refreshToken && integration.expiresAt)
      }
      // API key provider — accessToken alone is sufficient
      return true
    }
  }

  return false
}
